module.exports = __webpack_public_path__ + "static/media/hot02.afbc306d.jpg";